import { useQuery } from '@tanstack/react-query'
import { useSupabase } from '@/lib/supabase-context'
import { useOrganizacion } from '@/core/providers/OrganizacionProvider'
import { usePermissions } from '@/hooks/usePermissions'
import { reportesService } from '@/services/reportesService'

type FiltrosDeudores = { minDeuda?: number; maxDeuda?: number; estado?: string }

// Query keys
export const reportesKeys = {
  all: ['reportes'] as const,
  deudores: (organizacionId: string | null | undefined, filtros?: FiltrosDeudores) =>
    [...reportesKeys.all, 'deudores', organizacionId, filtros] as const,
  topDeudores: (organizacionId: string | null | undefined, limite: number) =>
    [...reportesKeys.all, 'topDeudores', organizacionId, limite] as const,
}

// Hook para obtener clientes deudores de la organización
export function useDeudores(filtros?: FiltrosDeudores) {
  const { supabase, isLoading: supabaseLoading } = useSupabase()
  const { organizacionId } = useOrganizacion()
  // La deuda sale de Pago y Deuda, que la RLS esconde sin verMovimientos (ORR-613): sin el flag
  // la lista saldría vacía sin error. La query no corre.
  const verMovimientos = usePermissions().puede.verMovimientos === true

  return useQuery({
    queryKey: reportesKeys.deudores(organizacionId, filtros),
    queryFn: () => reportesService.obtenerDeudores(supabase!, organizacionId!, filtros),
    enabled: !!supabase && !supabaseLoading && !!organizacionId && verMovimientos,
  })
}

/** Los clientes activos con mayor saldo y el total de activos con saldo positivo. */
export function useTopDeudores(limite = 10) {
  const { supabase, isLoading: supabaseLoading } = useSupabase()
  const { organizacionId } = useOrganizacion()
  const verMovimientos = usePermissions().puede.verMovimientos === true

  return useQuery({
    queryKey: reportesKeys.topDeudores(organizacionId, limite),
    queryFn: () => reportesService.obtenerTopDeudores(supabase!, organizacionId!, limite),
    enabled: !!supabase && !supabaseLoading && !!organizacionId && verMovimientos,
  })
}
